import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ExclusiveOffers from "./components/ExclusiveOffers";
import FleetSection from "./components/FleetSection";
import AboutSection from "./components/AboutSection";
import FeaturedTours from "./components/FeaturedTours";
import Testimonials from "./components/Testimonials";
import OfferBanner from "./components/OfferBanner";
import BlogSection from "./components/BlogSection";
import InstagramGrid from "./components/InstagramGrid";
import CTABanner from "./components/CTABanner";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

export default function App() {
  return (
    <div className="overflow-x-hidden">
      <Navbar />
      <Hero />
      <ExclusiveOffers />
      <FleetSection />
      <AboutSection />
      <FeaturedTours />
      <Testimonials />
      <OfferBanner />
      <BlogSection />
      <InstagramGrid />
      <CTABanner />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
